export const coreActionTypes = {
  EXIT_APP: 'CORE/EXIT_APP',
}

export const exitAppAction = payload => ({
  type: coreActionTypes.EXIT_APP,
  payload,
})
